
import { Outlet, Link } from 'react-router-dom';
import { apiService } from '../../../services';
import { MainZone, GridContainer, ProfileZone, ProfileSummary, LoginTile, Footer, Page } from '../../';
import { Header, MainNav, Notifications } from '../../';
import { ToastContainer } from 'react-toastify';

import { LanguageSelector } from '../../Translate/LanguageSelector.component';
import SocialIntentsChat from '../../Chat/SocialIntentsChat.component';

const isLoggedIn = apiService.instance.isLoggedIn();


export default function ZebraLayout() {
    return (<>
        {isLoggedIn ? (
            <>
                <LanguageSelector />
                <Notifications />
                <ToastContainer autoClose={false} closeOnClick />
                <Header />
                <div className='featureed-container'>
                    <div className='feature-campaign-container'>
                        <div className='content'>
                            <h1>Transport & Logistics</h1>
                            <hr />
                            <p>Sesame snaps sesame snaps halvah lollipop candy bear claw. Biscuit sesame snaps powder chocolate jujubes bear claw gummies. Caramels cheesecake gingerbread pastry gummies fruitcake gummi bears muffin.</p>
                            <Link className='btn btn-primary' to="/incentive/featured-campaign">Discover &gt;</Link>
                        </div>
                    </div>
                    <div className='carousel-container'>
                        <h3>Carousel</h3>
                    </div>
                </div>
                <main>
                    <div className='mt-3 flex-grow-1'>
                        <Outlet />
                    </div>
                    <div className='container'>
                        <Footer />
                    </div>
                </main>
                <SocialIntentsChat />
            </>
        ) : (
            <>
                <LanguageSelector />
                <LoginTile />
            </>
        )}
    </>
    );

}